import styled, { css } from 'styled-components';

import mixin from '../../_foundations/Mixin';

export const TabContainer = styled.div`
  ${(props) => {
    const spacing = props.spacing || '0rem';
    const bottomPadding =
      props.underline && props.tabStyle === 'default' ? '0.25rem' : '0rem';
    return css`
      ${mixin.horizontalFlow({ spacing })}
      padding-bottom: ${bottomPadding};
      ${props.underline &&
      props.tabStyle === 'default' &&
      mixin.border({ only: 'bottom' })}
    `;
  }}
`;
